import { AKComponent } from '@theme/component';

/**
 * Obfuscated Link Component
 * Renders clickable text that redirects without exposing the URL to crawlers
 */
class ObfuscatedLinkComponent extends AKComponent {
    constructor() {
        super();
        this.addEventListener('click', this.handleClick.bind(this));
        this.style.cursor = 'pointer';
        this.style.textDecoration = 'none';
        this.style.color = 'inherit';
    }

    connectedCallback() {
        super.connectedCallback();

        // Make it keyboard accessible
        if (!this.hasAttribute('tabindex')) {
            this.setAttribute('tabindex', '0');
        }
        
        // Add keyboard support
        this.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    handleClick(event) {
        event.preventDefault();
        this.navigate();
    }

    handleKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.navigate();
        }
    }

    navigate() {
        const url = this.getAttribute('data-url');
        if (url) {
            // Navigate to the URL
            window.location.href = url;
        }
    }
}

// Register the custom element
customElements.define('obfuscated-link', ObfuscatedLinkComponent);

export { ObfuscatedLinkComponent };